(function (script) {

    const scriptSrc = script.src;
    const scriptHost = scriptSrc.substring(0, scriptSrc.indexOf('/', 10));

    const octolizeDpd = window.octolizeDpd || {};
    const shipmentSettings = octolizeDpd?.shipmentSettings ?? {};
    const pickupShippingIds = toIntegerSet(shipmentSettings?.pickup);
    const codShippingIds = toIntegerSet(shipmentSettings?.cod);
    const foodShippingIds = toIntegerSet(shipmentSettings?.food);
    const parcelMachineShippingIds = toIntegerSet(shipmentSettings?.pointType?.parcel_machine);
    const customerServiceShippingIds = toIntegerSet(shipmentSettings?.pointType?.customer_service);
    let shippingsWithMapButton = new WeakSet();

    let basketShippingsApi = null;
    let basketAdditionalFieldsApi = null;
    let basketOrderApi = null;

    let flashMessengerApi = null;
    let selectedShippingId = null;
    let selectedShippingCountry = null;
    const pickupMapStateSyncTimeouts = new Set();
    const pickupMapStateSyncDelays = [0, 150, 500, 1000];
    const checkoutShippingRefreshEvents = [
        'basket.basketUpdated',
        'PageManager.rendered',
    ];

    function normalizeInteger(value) {
        const parsedValue = Number.parseInt(value, 10);

        return Number.isInteger(parsedValue) ? parsedValue : null;
    }

    function toIntegerSet(values = []) {
        return new Set(
            (Array.isArray(values) ? values : [])
                .map((value) => normalizeInteger(value))
                .filter((value) => value !== null),
        );
    }

    function getMapPopupElement() {
        return document.querySelector('.js--popup-dpd');
    }

    function prepareMapParams(shippingId, country) {
        const normalizedShippingId = normalizeInteger(shippingId);
        const params = new URLSearchParams();

        if (codShippingIds.has(normalizedShippingId)) {
            params.append('cod', '1');
        }

        if (foodShippingIds.has(normalizedShippingId)) {
            params.append('food', '1');
        }

        const onlyParcelMachine = parcelMachineShippingIds.has(normalizedShippingId) && !customerServiceShippingIds.has(normalizedShippingId);
        const onlyCustomerService = customerServiceShippingIds.has(normalizedShippingId) && !parcelMachineShippingIds.has(normalizedShippingId);
        if (onlyParcelMachine) {
            params.append('parcel_machine', '1');
            params.append('hide_filters', '1');
        } else if (onlyCustomerService) {
            params.append('customer_service', '1');
            params.append('hide_filters', '1');
        }

        if (country && country !== 'PL') {
            params.append('query', country);
        }

        return params.toString();
    }

    function showMapPopup(scriptHost, shippingId, country) {
        const mapIframe = document.getElementById('dpd-map-iframe');
        const src = scriptHost + "/pickup-points-map?" + prepareMapParams(shippingId, country);
        if (mapIframe && mapIframe.src !== src) {
            mapIframe.src = src;
        }
        const mapPopup = getMapPopupElement();
        if (mapPopup) {
            mapPopup.style.display = 'block';
        }
    }

    function hideMapPopup() {
        const mapPopup = getMapPopupElement();
        if (mapPopup) {
            mapPopup.style.display = 'none';
        }
    }

    function setMapButtonLabel(pointId) {
        const label = document.getElementById('dpd_button_label');
        if (!label) {
            return;
        }

        if (pointId) {
            label.innerHTML = 'Wybrany punkt: ' + pointId;
        } else {
            label.innerHTML = 'Wybierz punkt';
        }
    }

    function getPickupPointFieldId() {
        const fieldId = Number.parseInt(shipmentSettings?.pickupPointFieldId, 10);

        return Number.isInteger(fieldId) && fieldId > 0 ? fieldId : null;
    }

    function getSelectedShippingId() {
        const selectedShipping = basketShippingsApi?.getSelectedShipping?.();
        return normalizeInteger(selectedShipping?.id);
    }

    function getSelectedShippingCountry() {
        return basketShippingsApi?.getSelectedShippingCountry?.()?.country?.isocode ?? 'PL';
    }

    function isPickupShipping(shippingId) {
        return pickupShippingIds.has(normalizeInteger(shippingId));
    }

    function getPickupPointField() {
        const fieldId = getPickupPointFieldId();
        if (!fieldId || !basketAdditionalFieldsApi) {
            return null;
        }

        const additionalFields = basketAdditionalFieldsApi.get();

        return additionalFields?.hiddenFields?.find((field) => normalizeInteger(field.id) === fieldId) ?? null;
    }

    function getPickupPointValue() {
        return getPickupPointField()?.value ?? '';
    }

    async function changePickupPointValue(value) {
        const fieldId = getPickupPointFieldId();
        if (!fieldId || getPickupPointValue() === value) {
            return;
        }

        await basketAdditionalFieldsApi.change(fieldId, value);
    }

    async function resetPickupPointSelection() {
        await changePickupPointValue('');
        setMapButtonLabel('');
        removePickupValidationMessages();
    }

    function waitForStorefront() {
        if (typeof window.useStorefront === 'function') {
            initializeStorefrontLogic();
        } else {
            setTimeout(waitForStorefront, 100);
        }
    }

    function addShippingInfoToShippings() {
        const basketShippings = basketShippingsApi.get();

        basketShippings.forEach((shipping) => {
            if (isPickupShipping(shipping.id) && !shippingsWithMapButton.has(shipping)) {
                basketShippingsApi.addShippingInfo(shipping, 'dpd-map-button');
                shippingsWithMapButton.add(shipping);
            }
        })
    }

    function resetRegisteredMapButtons() {
        shippingsWithMapButton = new WeakSet();
    }

    function hasMapButtonInCheckout() {
        return document.querySelector('.octolize_dpd_map_button') !== null;
    }

    function clearScheduledPickupMapStateSyncs() {
        pickupMapStateSyncTimeouts.forEach((timeoutId) => {
            clearTimeout(timeoutId);
        });
        pickupMapStateSyncTimeouts.clear();
    }

    function validatePickupPointSelection() {
        const shippingId = getSelectedShippingId();
        if (getMapPopupElement() && isPickupShipping(shippingId)) {
            if (!getPickupPointFieldId()) {
                return false;
            }
            const pickupPointField = getPickupPointField();
            if (!pickupPointField || pickupPointField.value === '') {
                return false;
            }
        }
        return true;
    }

    function addValidationMessage() {
        if (flashMessengerApi) {
            const addPickupValidationFlashMessage = (content) => {
                const message = {
                    content,
                    type: 'error',
                    isCloseable: false,
                    timeout: 0
                };

                flashMessengerApi.addFlashMessage(message, 'shipping-chooser');
                flashMessengerApi.addFlashMessage(message, 'global');
            };

            if (!getPickupPointFieldId()) {
                addPickupValidationFlashMessage(`Błąd w konfiguracji sklepu: brak dodatkowego pola wyboru punktu odbioru.`);

                return;
            }

            addPickupValidationFlashMessage(`Proszę wybrać punkt odbioru.`);
        }
    }

    function removePickupValidationMessages() {
        flashMessengerApi?.removeAllFlashMessages('shipping-chooser');
        flashMessengerApi?.removeAllFlashMessages('global');
    }

    function addValidation() {
        basketOrderApi.addOrderValidation(
            validatePickupPointSelection,
            addValidationMessage
        );
    }

    function hasMethods(api, methods) {
        return methods.every((method) => typeof api?.[method] === 'function');
    }

    function initializeStorefrontLogic() {
        window.useStorefront((storefront) => {
            if (!hasMethods(storefront, ['hasApi', 'getApiSync']) || typeof storefront?.eventBus?.on !== 'function') {
                return;
            }

            const {eventBus, hasApi, getApiSync} = storefront;
            let initialized = false;

            const initializeCheckout = () => {
                const basketApiNames = ['basketShippingsApi', 'basketAdditionalFieldsApi', 'basketOrderApi'];
                if (initialized || !basketApiNames.every((apiName) => hasApi(apiName))) {
                    return;
                }

                basketShippingsApi = getApiSync('basketShippingsApi');
                basketAdditionalFieldsApi = getApiSync('basketAdditionalFieldsApi');
                basketOrderApi = getApiSync('basketOrderApi');

                if (!hasMethods(basketShippingsApi, ['get', 'addShippingInfo', 'getSelectedShipping', 'getSelectedShippingCountry'])
                    || !hasMethods(basketAdditionalFieldsApi, ['get', 'change'])
                    || !hasMethods(basketOrderApi, ['addOrderValidation'])) {
                    return;
                }

                const messenger = hasApi('FlashMessengerApi') ? getApiSync('FlashMessengerApi') : null;
                flashMessengerApi = hasMethods(messenger, ['addFlashMessage', 'removeAllFlashMessages']) ? messenger : null;
                initialized = true;

                addShippingInfoToShippings();
                addValidation();
                selectedShippingId = getSelectedShippingId();
                selectedShippingCountry = getSelectedShippingCountry();

                window.addEventListener('message', async (event) => {
                    if (event.origin !== scriptHost) return;

                    const {type, payload} = event.data || {};
                    if (type === 'octolize:dpdPointSelected') {
                        await changePickupPointValue(payload);
                        hideMapPopup();
                        setMapButtonLabel(payload);
                        removePickupValidationMessages();
                    }
                });


                document.addEventListener('click', async (event) => {
                    // Show map popup.
                    if (event.target.closest('.octolize_dpd_map_button')) {
                        const shippingId = getSelectedShippingId();
                        if (shippingId !== null) {
                            showMapPopup(scriptHost, shippingId, getSelectedShippingCountry());
                        }
                    }

                    // Hide map popup.
                    if (event.target.closest('.js--popup-close-button-dpd')) {
                        event.preventDefault();
                        hideMapPopup();
                    }
                });

                const syncPickupMapState = async (refreshMissingMapButton = false) => {
                    const currentShippingId = getSelectedShippingId();
                    const currentShippingCountry = getSelectedShippingCountry();
                    const shippingChanged = currentShippingId !== selectedShippingId;
                    const countryChanged = currentShippingCountry !== selectedShippingCountry;

                    if (refreshMissingMapButton && !hasMapButtonInCheckout()) {
                        resetRegisteredMapButtons();
                    }

                    addShippingInfoToShippings();

                    selectedShippingId = currentShippingId;
                    selectedShippingCountry = currentShippingCountry;

                    if (shippingChanged || (countryChanged && isPickupShipping(currentShippingId))) {
                        await resetPickupPointSelection();
                    }
                };

                const schedulePickupMapStateSync = (delays = [0], refreshMissingMapButton = false) => {
                    clearScheduledPickupMapStateSyncs();

                    delays.forEach((delay) => {
                        const timeoutId = setTimeout(() => {
                            pickupMapStateSyncTimeouts.delete(timeoutId);
                            syncPickupMapState(refreshMissingMapButton).catch((error) => {
                                console.error('Failed to synchronize DPD pickup map state', error);
                            });
                        }, delay);

                        pickupMapStateSyncTimeouts.add(timeoutId);
                    });
                };

                const scheduleCheckoutShippingRefresh = () => schedulePickupMapStateSync(pickupMapStateSyncDelays, true);

                // Clear selected pickup point when shipping method or country is changed.
                checkoutShippingRefreshEvents.forEach((eventName) => {
                    eventBus.on(eventName, scheduleCheckoutShippingRefresh);
                });

            };

            eventBus.on('basket.initialized', initializeCheckout);
            initializeCheckout();
        });
    }

    waitForStorefront();
}(document.currentScript));
